var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"data-view"},[_c('router-view')],1),_c('div',{staticClass:"copyright"},[_vm._v(" 京ICP备17041952号-2 京公网安备11010802029194 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }